export default __webpack_public_path__ + "static/media/242.4b705a3d.png";